import { Tag } from '@chakra-ui/react';

import { MeetingFieldsFragment } from '@/@generated/codegen/API';
import {
  getMeetingStatus,
  getMeetingstatusColor,
  getMeetingStatusText,
} from '@/features/meeting/helpers/getMeetingStatus';

type Props = {
  meeting: MeetingFieldsFragment;
};

export const MeetingStatusTag = ({ meeting }: Props) => {
  const status = getMeetingStatus(meeting);
  return (
    <Tag ml={2} colorScheme={getMeetingstatusColor(status)}>
      {getMeetingStatusText(status)}
    </Tag>
  );
};
